import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Play Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1010%3A23781&mode=dev)
 * */

const PlayIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M1.4707 1.90079V10.0992C1.47069 10.2208 1.5022 10.3403 1.56215 10.446C1.6221 10.5518 1.70844 10.6402 1.81276 10.7026C1.91707 10.7651 2.03578 10.7994 2.15732 10.8022C2.27885 10.8051 2.39904 10.7764 2.50617 10.7189L10.1576 6.6197C10.2697 6.55961 10.3634 6.47024 10.4287 6.36111C10.494 6.25199 10.5285 6.12719 10.5285 6.00001C10.5285 5.87283 10.494 5.74803 10.4287 5.63891C10.3634 5.52978 10.2697 5.44041 10.1576 5.38032L2.50617 1.2811C2.39904 1.22364 2.27885 1.19494 2.15732 1.1978C2.03578 1.20065 1.91707 1.23497 1.81276 1.29739C1.70844 1.35982 1.6221 1.44822 1.56215 1.55398C1.5022 1.65973 1.47069 1.77923 1.4707 1.90079Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PlayIcon;